import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { EquipmentCategory, EquipmentDto } from 'src/modules/generated/api';

import CarDetailEquipmentByCategory from './CarDetailEquipmentByCategory';

type CarDetailEquipmentContainerProps = {
  equipments: EquipmentDto[];
};

const CarDetailEquipmentContainer = ({ equipments }: CarDetailEquipmentContainerProps) => {
  const { t } = useTranslation();

  const equipmentsByCategory = equipments.reduce(
    (acc, equipment) => {
      switch (equipment.category) {
        case EquipmentCategory.BasicEquipment:
          acc.basicEquipment.push(equipment);
          break;
        case EquipmentCategory.SpecialEquipment:
          acc.specialEquipment.push(equipment);
          break;
        case EquipmentCategory.PackageEquipment:
          acc.packageEquipment.push(equipment);
          break;
        default:
          acc.undefinedEquipment.push(equipment);
      }
      return acc;
    },
    {
      basicEquipment: [] as EquipmentDto[],
      specialEquipment: [] as EquipmentDto[],
      packageEquipment: [] as EquipmentDto[],
      undefinedEquipment: [] as EquipmentDto[],
    },
  );

  // Extract individual arrays if needed
  const { basicEquipment, specialEquipment, packageEquipment, undefinedEquipment } = equipmentsByCategory;

  // We assume that if no basic equipments are there and all others (except for "Anschlussgarantie") are undefined,
  // we don't have categories for the equipments of that car and thus use the old depiction.
  const useOldDepiction =
    basicEquipment.length === 0 && specialEquipment.length <= 1 && undefinedEquipment.length >= equipments.length - 1;

  if (useOldDepiction) {
    return (
      <Grid item xs={12}>
        <CarDetailEquipmentByCategory equipments={equipments} overrideTitle={t('car.equipment')} category={undefined} />
      </Grid>
    );
  }

  return (
    <>
      {packageEquipment.length > 0 && (
        <Grid item xs={12}>
          <CarDetailEquipmentByCategory equipments={packageEquipment} category={EquipmentCategory.PackageEquipment} />
        </Grid>
      )}
      {specialEquipment.length > 0 && (
        <Grid item xs={12}>
          <CarDetailEquipmentByCategory equipments={specialEquipment} category={EquipmentCategory.SpecialEquipment} />
        </Grid>
      )}
      {basicEquipment.length > 0 && (
        <Grid item xs={12}>
          <CarDetailEquipmentByCategory equipments={basicEquipment} category={EquipmentCategory.BasicEquipment} />
        </Grid>
      )}
      {undefinedEquipment.length > 0 && (
        <Grid item xs={12}>
          <CarDetailEquipmentByCategory equipments={undefinedEquipment} category={undefined} />
        </Grid>
      )}
    </>
  );
};

export default CarDetailEquipmentContainer;
